module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ar-a020c65068be7c76664db653bad53daf.svg";